import {Tab} from '@mui/material';
import {withStyles} from 'tss-react/mui';

const CustomTab = withStyles(Tab, {
  root: {
    backgroundColor: ''
  },
  selected: {
    backgroundColor: 'white',
    '&:first-child': {
      borderTopLeftRadius: '10px',
      borderBottomLeftRadius: '10px'
    }
  }
});

export default CustomTab;
